"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicWeak = void 0;
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var MicWeak = function MicWeak(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/_react.default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 9.5332H14.9295C14.9295 10.9258 14.4351 12.0814 13.4463 12.9999C12.4866 13.8888 11.3378 14.3332 10 14.3332C8.66219 14.3332 7.49888 13.8888 6.51007 12.9999C5.55034 12.0814 5.07047 10.9258 5.07047 9.5332H3.5C3.5 11.1332 4.03803 12.5406 5.11409 13.7554C6.21924 14.9406 7.54251 15.6517 9.08389 15.8888V17.9999H6.25V19.4999H13.75V17.9999H10.9161V15.8888C12.4575 15.6517 13.7662 14.9406 14.8423 13.7554C15.9474 12.5406 16.5 11.1332 16.5 9.5332Z",
    fill: "#EEEEF3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.4297 11.008C11.0114 11.4342 10.5472 11.6278 10.0019 11.6278C9.45662 11.6278 8.99242 11.4342 8.57407 11.008C8.15545 10.5815 7.95996 10.102 7.95996 9.53333V3.84444C7.95996 3.27577 8.15545 2.7963 8.57407 2.36981C8.99242 1.94359 9.45662 1.75 10.0019 1.75C10.5472 1.75 11.0114 1.94359 11.4297 2.36981C11.8484 2.7963 12.0439 3.27577 12.0439 3.84444V9.53333C12.0439 10.102 11.8484 10.5815 11.4297 11.008Z",
    stroke: "#EEEEF3",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.4297 11.0078C11.0114 11.4341 10.5472 11.6276 10.0019 11.6276C9.45662 11.6276 8.99242 11.4341 8.57407 11.0078C8.34382 10.7733 8.18107 10.5227 8.08123 10.25H11.9226C11.8227 10.5227 11.66 10.7733 11.4297 11.0078Z",
    fill: "#EEEEF3",
    stroke: "#EEEEF3",
    strokeWidth: "1.5"
  })));
};
exports.MicWeak = MicWeak;